import update from 'external/immutability-helper'


export function token(size = 50) {
  return tokenHelper(Math.max(1, Math.min(1000, size)), "")
}
function rand () { return Math.random().toString(36).substr(2) }
function tokenHelper(size, value) {
  return value.length >= size
    ? value.substring(0, size)
    : tokenHelper(size, value + rand()) 
}

export function shuffleArray(array = []) {
  return array.reduce((array, element, index, src) => {
    const i = src.length - 1 - index
    const j = Math.floor(Math.random() * (i + 1))
    if (i == j) {
      return array
    } else {
      const a = array[i]
      const b = array[j]
      return update(array, {$splice: [[i,1],[i,0,b],[j,1],[j,0,a]]})
    }
  }, array)
}
